import _axios from '@/utils/request'

export function postEditLabel (params) {
    return _axios('post', `/ms-shulan-hospital/v1/label/save`, params)
}

export function postLabelList (params) {
    return _axios('post', `/ms-shulan-hospital/v1/label/list`, params)
}

export function deleteLabel (id) {
    return _axios('delete', `/ms-shulan-hospital/v1/label/remove/${id}`)
}

export function postCheckLabel (params) {
    return _axios('post', `/ms-shulan-hospital/v1/label/checkout`, params)
}
